"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACTION_LINK_ICON_NAME", {
  enumerable: true,
  get: function get() {
    return _Icon.ICON_NAME;
  }
});
Object.defineProperty(exports, "ACTION_LINK_ICON_SIZE", {
  enumerable: true,
  get: function get() {
    return _Icon.ICON_SIZE;
  }
});
exports.ActionLink = exports.ACTION_LINK_THEME = exports.ACTION_LINK_TARGET = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./ActionLink.scss");
var ACTION_LINK_THEME = /*#__PURE__*/function (ACTION_LINK_THEME) {
  ACTION_LINK_THEME["default"] = "default";
  ACTION_LINK_THEME["dark"] = "dark";
  return ACTION_LINK_THEME;
}(ACTION_LINK_THEME || {});
exports.ACTION_LINK_THEME = ACTION_LINK_THEME;
var ACTION_LINK_TARGET = /*#__PURE__*/function (ACTION_LINK_TARGET) {
  ACTION_LINK_TARGET["self"] = "_self";
  ACTION_LINK_TARGET["blank"] = "_blank";
  ACTION_LINK_TARGET["parent"] = "_parent";
  ACTION_LINK_TARGET["top"] = "_top";
  return ACTION_LINK_TARGET;
}(ACTION_LINK_TARGET || {});
exports.ACTION_LINK_TARGET = ACTION_LINK_TARGET;
var ActionLink = function ActionLink(_ref) {
  var _classNames;
  var iconName = _ref.iconName,
    children = _ref.children,
    href = _ref.href,
    onClick = _ref.onClick,
    className = _ref.className,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? ACTION_LINK_THEME["default"] : _ref$theme,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? _Icon.ICON_SIZE["default"] : _ref$iconSize,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? ACTION_LINK_TARGET.self : _ref$target;
  var rootClassName = (0, _classnames["default"])('cds-ActionLink', (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-ActionLink--".concat((0, _upperCaseFirst.upperCaseFirst)(theme)), theme), (0, _defineProperty2["default"])(_classNames, 'cds-Link', !!href), (0, _defineProperty2["default"])(_classNames, 'cds-ButtonLink', !href), _classNames), className);
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, iconName && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: iconName,
    size: iconSize,
    className: "cds-ActionLink-Icon"
  }), children && /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-ActionLink-Content"
  }, children));
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: rootClassName,
      target: target
    }, content);
  }
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: rootClassName
  }, content);
};
exports.ActionLink = ActionLink;
ActionLink.config = {
  theme: ACTION_LINK_THEME,
  target: ACTION_LINK_TARGET,
  iconName: _Icon.ICON_NAME,
  iconSize: _Icon.ICON_SIZE
};